import initWarning from "components/jiffy/ie11-warning/ie11-warning";

document.addEventListener("DOMContentLoaded", () => {
  initWarning();
});
